import React, { useState } from 'react';
import { Honorarvereinbarung } from './components/Honorarvereinbarung';
import { RechnungEditor } from './components/RechnungEditor';
import { RechnungsArchiv } from './components/RechnungsArchiv';

type AbrTab = 'rechnung' | 'archiv' | 'honorar';

const TABS: { key: AbrTab; label: string; icon: string }[] = [
  { key: 'rechnung', label: 'Neue Rechnung',     icon: '📄' },
  { key: 'archiv',   label: 'Archiv',             icon: '🗂' },
  { key: 'honorar',  label: 'Honorarvereinbarung', icon: '💶' },
];

export function AbrechnungModul(): React.JSX.Element {
  const [tab, setTab] = useState<AbrTab>('rechnung');

  return (
    <div className="flex flex-col h-full">
      <div className="border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-6 pt-4 flex gap-1">
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => { setTab(t.key); }}
            className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-t-lg border-b-2 transition-colors
              ${tab === t.key
                ? 'border-blue-600 text-blue-700 dark:text-blue-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
          >
            <span>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto">
        {tab === 'rechnung' && <RechnungEditor />}
        {tab === 'archiv'   && <RechnungsArchiv />}
        {tab === 'honorar'  && <Honorarvereinbarung />}
      </div>
    </div>
  );
}
